import React, {PropsWithChildren} from 'react';
import useResizeObserver from 'use-resize-observer';
import {Content} from './styled';

type ComputedBoxProps = PropsWithChildren & {expanded: boolean; className?: string};
function ComputedBox({expanded, className, children}: ComputedBoxProps) {
  const {ref: contentRef, height} = useResizeObserver({box: 'border-box'});

  return (
    <Content $expanded={expanded} height={height} className={className}>
      <div ref={contentRef}>{children}</div>
    </Content>
  );
}

export {ComputedBox};
